import { createFileRoute, Link } from '@tanstack/react-router';
import { usePayrollRuns } from '../../hooks/usePayroll';
import { useActiveCompanyId } from '../../stores/useCompanyStore';
import { formatAccountingDate, formatCurrency } from '../../lib/formatters';

export const Route = createFileRoute('/_auth/payroll/')({
  component: PayrollPage,
});

function PayrollPage() {
  const companyId = useActiveCompanyId();
  const { data: runs = [], isLoading, error } = usePayrollRuns(companyId);

  if (!companyId) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: 32 }}>
        <h1 style={{ marginTop: 0 }}>Payroll</h1>
        <p className="muted">No active company.</p>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h1 style={{ fontSize: 24, margin: 0 }}>Payroll</h1>
          <p className="muted" style={{ margin: '4px 0 0', fontSize: 13 }}>Enter paystubs; each run posts one balanced journal entry.</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <Link to="/payroll/uncashed" className="btn-secondary" style={{ textDecoration: 'none' }} title="Net pay that has left the payroll register but not yet the bank, by person">Uncashed cheques</Link>
          <Link to="/payroll/mappings" className="btn-secondary" style={{ textDecoration: 'none' }}>GL Mapping</Link>
          <Link to="/payroll/new" className="btn-primary" style={{ textDecoration: 'none' }}>+ New payroll run</Link>
        </div>
      </div>

      {isLoading && <p className="muted">Loading…</p>}
      {error && <p className="field-error">Failed to load payroll runs.</p>}

      {!isLoading && runs.length === 0 && (
        <div className="card" style={{ textAlign: 'center', padding: 32 }}>
          <p className="muted" style={{ marginTop: 0 }}>No payroll runs yet.</p>
          <Link to="/payroll/new" className="btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>Enter your first payroll run</Link>
        </div>
      )}

      {runs.length > 0 && (
        <table className="table">
          <thead>
            <tr>
              <th>Pay date</th>
              <th>Period</th>
              <th style={{ textAlign: 'right' }}>Gross</th>
              <th style={{ textAlign: 'right' }}>Net pay</th>
              <th>Status</th>
              <th style={{ width: 1 }}></th>
            </tr>
          </thead>
          <tbody>
            {runs.map((r) => (
              <tr key={r.id} style={{ opacity: r.status === 'void' ? 0.55 : 1 }}>
                <td style={{ fontWeight: 500 }}>{formatAccountingDate(r.payDate)}</td>
                <td className="muted">{formatAccountingDate(r.periodStart)} – {formatAccountingDate(r.periodEnd)}</td>
                <td style={{ textAlign: 'right' }}>{formatCurrency(r.totalGross)}</td>
                <td style={{ textAlign: 'right' }}>{formatCurrency(r.totalNet)}</td>
                <td>{r.status === 'void' ? <span className="tag">void</span> : <span className="tag ok">posted</span>}</td>
                <td>
                  <Link to="/payroll/$id" params={{ id: r.id }} className="btn-secondary" style={{ textDecoration: 'none' }}>View</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
